window.Questions = Backbone.Model.extend({
	model: Question
});
